import * as S from './style';
import FormLogin from '../../components/FormLogin';
import imgLogin from '../../assets/ImgLogin.svg'

export default function Login() {
    return (
        <S.Container>
            <S.ContentImage>
                <S.Image src={imgLogin} alt='Imagem do Login' />
            </S.ContentImage>
            <S.ContentForm>
                <FormLogin />
            </S.ContentForm>
        </S.Container>
    )
}